export enum Errors {
  none = '',
  loading = 'Unable to load todos',
  requiredTitle = 'Title should not be empty',
  adding = 'Unable to add a todo',
  deleting = 'Unable to delete a todo',
  updating = 'Unable to update a todo',
}
